import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';

interface SubTab {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface SubTabNavProps {
  tabs: SubTab[];
  value: string;
  onChange: (value: string) => void;
}

export const SubTabNav: React.FC<SubTabNavProps> = ({ tabs, value, onChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        mb: 2.5,
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
    >
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => {
          if (newValue !== null) onChange(newValue);
        }}
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          minWidth: 'min-content',
        }}
      >
        {tabs.map((tab) => (
          <ToggleButton
            key={tab.value}
            value={tab.value}
            sx={{
              px: isMobile ? 1.5 : 2,
              py: 0.75,
              gap: 0.75,
              whiteSpace: 'nowrap',
            }}
          >
            {tab.icon}
            {tab.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};
